import { dynamic } from '#/utils/dynamic';

export const orgDashboardModalComponentByType = {
  SHARE_NEW_LISTING: dynamic(
    () =>
      import('./ShareNewListing/ShareNewListingModal').then((module) => ({
        default: module.ShareNewListingModal,
      })),
    { strategy: 'always' },
  ),
  DELETE_LISTING: dynamic(
    () =>
      import('./DeleteListing/OrgDashboardDeleteListingModal').then(
        (module) => ({
          default: module.OrgDashboardDeleteListingModal,
        }),
      ),
    { strategy: 'always' },
  ),
  DELETE_ORG: dynamic(
    () =>
      import('./DeleteOrg/DeleteOrgModal').then((module) => ({
        default: module.DeleteOrgModal,
      })),
    { strategy: 'always' },
  ),
  VAT_NUMBER: dynamic(
    () =>
      import('./VatNumber/VatNumberModal').then((module) => ({
        default: module.VatNumberModal,
      })),
    { strategy: 'always' },
  ),
  HIDE_REPOSTED_LISTINGS: dynamic(
    () =>
      import('./OrgHideRepostedListings/OrgHideRepostedListingsModal').then(
        (module) => ({ default: module.OrgHideRepostedListingsModal }),
      ),
    { strategy: 'always' },
  ),
  CONTACT_CANDIDATE: dynamic(
    () =>
      import('./ContactCandidate/ContactCandidateModal').then((module) => ({
        default: module.ContactCandidateModal,
      })),
    { strategy: 'always' },
  ),
  AUTO_PUBLISH_INTEGRATION: dynamic(
    () =>
      import('./AutoPublishIntegration/AutoPublishIntegrationModal').then(
        (module) => ({ default: module.AutoPublishIntegrationModal }),
      ),
    { strategy: 'always' },
  ),
  DELETE_INTEGRATION: dynamic(
    () =>
      import('./DeleteIntegration/DeleteIntegrationModal').then((module) => ({
        default: module.DeleteIntegrationModal,
      })),
    { strategy: 'always' },
  ),
  CHECKOUT_FEEDBACK: dynamic(
    () =>
      import('./CheckoutFeedback/CheckoutFeedbackModal').then((module) => ({
        default: module.CheckoutFeedbackModal,
      })),
    { strategy: 'always' },
  ),
} as const satisfies Record<string, unknown>;
